import React from "react"
import {createRoot} from "react-dom/client"
import "./index.css"
import App from "./App"
import VistaprintAuth from "@vp/auth"

VistaprintAuth.init(
	{
		// CSE-4859: the DOM-XSS is closed by the @vp/auth 7.x upgrade alone — 7.x
		// routes every redirect through an it()/sanitizeUrl guard that blocks
		// javascript:/data: URIs (invalidProtocolRegex), so the raso/#state sink
		// is safe regardless of developmentMode.
		//
		// developmentMode MUST stay: in @vp/auth 7.0.16 the entire authorization-
		// code return handler is gated behind `developmentMode && function(){…}`.
		// It is the only code path that reads ?code=&state= on return, exchanges
		// the PKCE code for tokens, and establishes the session. Removing it (as
		// the original CSE-4859 change did) means the code is never exchanged,
		// isSignedIn stays false, and the app loops through signIn() forever —
		// each bounce nesting the URL into state.redirectUrl until it 414s.
		developmentMode: {
			clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
		},
		options: {
			connection: "vista-okta",
			requireSession: true,
		},
		enableCrossSiteSso: true,
		culture: "en-US",
	},
	(identity: any) => {
		if (!identity || !identity.isSignedIn) {
			new VistaprintAuth.WebAuth().signIn()
		} else {
			const container = document.getElementById("root")
			const root = createRoot(container!)
			root.render(
				<React.StrictMode>
					<App />
				</React.StrictMode>
			)
		}
	}
)
